import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Pipe({
  name: 'highlighter',
})
export class HighlighterPipe implements PipeTransform {
  // -------------------------------------------------------------------- old code -----------------------------------------------------------
  /* transform(value: any, argsObj: any,type:string): unknown {
	let args = argsObj['searchText'];
	let x = argsObj['x'];
	let y = argsObj['y'];
	console.log('argsObj', argsObj);
	console.log('value', value);
	console.log('args', args);
	

    if(!args) return value;

    let query = args;

	   	if ( query ) {
	        value = value?.changingThisBreaksApplicationSecurity || value;

      let tagRE = new RegExp('<[^<>]*>', 'ig');

	        // get ist of tags
	        let tagList  = value?.match( tagRE );

	        // Replace tags with token
	        let tmpValue = value?.replace( tagRE, '$!$');

	        // Replace search words
	        value = tmpValue?.replace(
	            new RegExp(query, 'gi'),
	            '<mark>$&</mark>'
	        );

	        // Reinsert HTML
	        for (let i = 0; value?.indexOf('$!$') > -1; i++) {
	            value = value?.replace('$!$', tagList[i]);
	        }
	    }

      return value;
  } */

  // -------------------------------------------------------------- end ------------------------------------------------

  // ------------------------------------------- code with new logic (highlight with Co-ordinate) ------------------------------------------------

  constructor(private sanitizer: DomSanitizer) {}

  transform(value: any, argsObj: any, type: string): SafeHtml {
    let searchText = argsObj['searchText'];
    let x = argsObj['x'];
    let y = argsObj['y'];
    let lang = argsObj['lang'];
    const hasBlankXY = x === null || x === '' || y === undefined || y === '';

    if (!searchText) return value;
    // if (!searchText && (x === undefined || y === undefined)) return value;

    // In case value is a SafeHtml already
    value = value?.changingThisBreaksApplicationSecurity || value;

    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${value}</div>`, 'text/html'); // Wrap with <div> for valid parsing

    // Step 1: Highlight span with exact x & y
    if (x !== undefined && y !== undefined) {
      const spans = doc.querySelectorAll('span[x][y]');
      spans.forEach((span) => {
        if (
          span.getAttribute('x') === String(x) &&
          span.getAttribute('y') === String(y)
        ) {
          const content = span.innerHTML;
          //   span.innerHTML = `<mark>${content}</mark>`;
          span.innerHTML = `<mark x='${x}' y='${y}'>${content}</mark>`;
        }
      });
    }

    if (hasBlankXY) {
      const spans = doc.querySelectorAll('span[x][y]');
      // const endExceptions = ['','.', '&nbsp;', ' &nbsp;', '.&nbsp;', '. &nbsp;', '.1.', '.2.', '.3.', '.4.', '.5.', '.6.', '.7.', '.8.', '.9.'];
      const endExceptions = environment.baniTextEndExceptions;
      const trimmedSearch = searchText.trim();

      spans.forEach((span) => {
        const apiXvalue = span.attributes[2].value;
        const apiYvalue = span.attributes[3].value;
        const apiText = span.innerHTML.trim();

        if (
          endExceptions.some((end) => apiText === trimmedSearch + end) ||
          apiText == trimmedSearch
        ) {
          span.innerHTML = `<mark x='${apiXvalue}' y='${apiYvalue}'>${span.innerHTML}</mark>`;
        }
      });
    }

    // Step 2: Highlight search text (outside tags)
    if (searchText && lang === null) {
      const regex = new RegExp(searchText, 'gi');
      const treeWalker = doc.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT);

      const textNodes: Text[] = [];
      while (treeWalker.nextNode()) {
        textNodes.push(treeWalker.currentNode as Text);
      }
      // console.log('lang :', lang);
      for (const node of textNodes) {
        if (!node.parentElement?.closest('mark')) {
          //   const replaced = node.nodeValue?.replace(regex, match => `<mark>${match}</mark>`);
          const spans = doc.querySelectorAll('span[x][y]');
          const replaced = node.nodeValue?.replace(
            regex,
            (match, offset, string) => {
              // If spans exist, don't wrap
              if (spans.length > 0) {
                return `${match}`;
              }

              // Get the next character after the match
              const nextChar = string[offset + match.length];

              // If nextChar is in endExceptions, don't wrap
              if (/[a-zA-Z]/.test(nextChar)) {
                return `${match}`;
              }

              // Otherwise, wrap with mark
              return `<mark>${match}</mark>`;
            }
          );
          if (replaced !== node.nodeValue) {
            const span = doc.createElement('span');
            span.innerHTML = replaced!;
            node.replaceWith(...Array.from(span.childNodes));
          }
        }
      }
    }

    return this.sanitizer.bypassSecurityTrustHtml(doc.body.innerHTML);
  }

  // --------------------------------------------------------------------------------------------------------

  /* transform(value: any, args: any,type:string): unknown {
    if(!args) return value;
    console.log(value);
    console.log(args);
    console.log(type);

    if(type==='full'){
console.log('v');
      const re = new RegExp("\\b("+args+"\\b)", 'igm');
      value= value.replace(re, '<span class="highlighted-text">$1</span>');

    }else{
console.log('vj');

      const re = new RegExp(args, 'igm');
      value= value.replace(re, '<span class="highlighted-text">$&</span>');

    }

      return value;
  }*/
}
